import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { CurvaAbcVendaRoutingModule } from './curva-abc-venda-routing.module';
import { CurvaAbcVendaSelectModule } from './referencia/select';
import { CurvaAbcVendaFilterModule } from './filter';
import { CurvaAbcVendaPerspectivaNavModule } from './perspectiva/nav';
import { CurvaAbcVendaReportModalModule } from './report/modal';
import { CurvaAbcVendaExcelModule } from './excel';

import { CurvaAbcVendaComponent } from './curva-abc-venda.component';

@NgModule({
    imports: [
        SharedModule,
        CurvaAbcVendaRoutingModule,
        CurvaAbcVendaSelectModule,
        CurvaAbcVendaFilterModule,
        CurvaAbcVendaPerspectivaNavModule,
        CurvaAbcVendaReportModalModule,
        CurvaAbcVendaExcelModule
    ],
    declarations: [
        CurvaAbcVendaComponent
    ],
    exports: [
        CurvaAbcVendaComponent
    ]
})
export class CurvaAbcVendaModule {}
